<template>
    <Tooltip>
        <template #trigger="tooltipProps">
            <span
                :aria-describedby="tooltipProps['aria-labelledby']"
                class="inline-flex items-center justify-center rounded-sm ring-1 ring-inset leading-none min-w-max p-1.5"
                :class="[variantClasses]"
                tabindex="0"
            >
                <slot />
            </span>
        </template>

        <template #text>
            <div class="w-max">{{ props.tooltipText }}</div>
        </template>
    </Tooltip>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import Tooltip from '../Tooltip/Tooltip.vue';

export type LoginMethodBadgeVariant = 'Koelnmesse' | 'Sky';

type LoginMethodBadgeProps = {
    variant: LoginMethodBadgeVariant;
    tooltipText: string;
};

const props = defineProps<LoginMethodBadgeProps>();

const variantClasses = computed(() => {
    switch (props.variant) {
        case 'Koelnmesse':
            return 'bg-koelnmesse/10 text-gray-700 ring-koelnmesse/10 focus-visible:outline-2 focus-visible:outline-offset-1 focus-visible:outline-koelnmesse';

        case 'Sky':
            return 'bg-sky-100 text-gray-700 ring-sky-600/10 focus-visible:outline-2 focus-visible:outline-offset-1 focus-visible:outline-sky-700';

        default: {
            const exhaustiveCheck: never = props.variant;
            throw new Error(`Unknown LoginMethodBadge variant: ${exhaustiveCheck}`);
        }
    }
});
</script>
